/// <reference path="Utilities/_reference.ts" />

module YVR.ParkingData {
	// Dependencies
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;

	//Parkade data interface
	interface IParkade {
		zone?: string;
		available?: string;
		capacity?: Number;
	}

	//Parkade Collection Interface
	interface IParkadeCollection {
		value: IParkade[];
	}

	//cache parkade data
	let parkadeCache: IParkade[] = [];

	let options;
	options = {
		serviceUrl: '/_api/ParkadeCapacity'
	};


	// CSS Classes
	const classes = {
		num: 'availability-number',
		color: 'progress-color'
	};

	// Cached jQuery elements
	const elements = {
		parkadeWidget: $('.parkade-capacity')
	};

	//main function
	function main() {
		if (elements.parkadeWidget.length > 0) {
			console.log('parkade-data');
			getParkadeInfo();
		}
	}

	function getParkadeInfo() {
		console.log('get parkade info');
		if (elements.parkadeWidget.length) {
			callParkadeApi()
				.then(renderParkadeData)
				.fail(() => {
					logger.error('[parkade-data][getParkadeInfo] An error occured retrieving the parkade data.');
					console.log('failed to get parkade data');
					//show error message here
				});
		}
	}

	function renderParkadeData(data: IParkadeCollection) {
		if (data && data.value && data.value.length) {
			console.log('rendering parkade');
			parkadeCache = data.value;

			console.log(parkadeCache);

			//Parkade Capacity
			//P1: 350
			//P2: 516
			//P3: 461

			data.value.forEach(function (parkade) {
				window['parkade'] = parkade;
				console.log('data-zone=["' + parkade.zone + '"]' + '.' + classes.num);
				let panel = elements.parkadeWidget.find('[data-zone="' + parkade.zone + '"]');

				if (panel.length) {
					window['bob'] = panel.find('.' + classes.num);
					console.log('num:' + classes.num);
					panel.find('.' + classes.num).html(parkade.available);


					//fill in bar
					if (parkade.zone === 'P1') {
						parkade.capacity = 350;
					}
					else if (parkade.zone === 'P2') {
						parkade.capacity = 516;
					}
					else if (parkade.zone === 'P3') {
						parkade.capacity = 461;
					}

					var available = Number(parkade.available);
					var percent = 100 - (available / parkade.capacity * 100);
					if (percent > 100) {
						percent = 100;
					}

					var progressColor;

					if (percent >= 80) {
						progressColor = 'red';
					}
					else if (percent < 80 && percent >= 50) {
						progressColor = 'yellow';
					}
					else if (percent < 50) {
						progressColor = 'green';
					}

					percent = percent.toFixed(2) + '%';

					panel.find('.' + classes.color).addClass(progressColor);
					panel.find('.' + classes.color).css('width', percent);
				}
			});

			return true;
		}
	}

	// calls API for parkade info. API is on Fishtank side
	function callParkadeApi(): JQueryPromise<IParkadeCollection> {
		return $.get({
			url: options.serviceUrl,
			success() {
				logger.log('Successfully retrieved parkade info data.');
			}
		});
	}

	main();
}
